import * as msal from "@azure/msal-browser";

export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_signupsignin1",
        editProfile: "B2C_1_profileediting1",
        resetPassword: "B2C_1_passwordreset1",
        changePassword: "B2C_1_passwordreset1",
    },
    authorities: {
        signUpSignIn: {
            authority: "https://uwlaportals.b2clogin.com/uwlaportals.onmicrosoft.com/B2C_1_signupsignin1",
        },
        editProfile: {
            authority: "https://uwlaportals.b2clogin.com/uwlaportals.onmicrosoft.com/B2C_1_profileediting1",
        },
        resetPassword: {
            authority: "https://uwlaportals.b2clogin.com/uwlaportals.onmicrosoft.com/B2C_1_passwordreset1",
        },
        changePassword: {
            authority: "https://uwlaportals.b2clogin.com/uwlaportals.onmicrosoft.com/B2C_1_passwordreset1",
        }
    },
    authorityDomain: "uwlaportals.b2clogin.com"
};

export const msalConfig = {
    auth: {
        clientId: 'd5af6458-fe23-4d74-b932-0fc6e80a6797', // Your application ID
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: process.env.REACT_APP_AUTHORITY_URL ,//'https://agencyhub.unitedwayla.org',//'https://vtmonodeapps-cnete5hvcxg7eyde.westus2-01.azurewebsites.net', // 'http://localhost:3000/', //
        postLogoutRedirectUri: process.env.REACT_APP_AUTHORITY_URL ,//'https://agencyhub.unitedwayla.org',//'https://vtmonodeapps-cnete5hvcxg7eyde.westus2-01.azurewebsites.net', // Redirects to home page after logout //'http://localhost:3000/', //
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) { 
                    return;
                }
                switch (level) {
                    case msal.LogLevel.Error:
                        console.error(message);
                        return;
                    case msal.LogLevel.Info:
                        console.info(message);
                        return;
                    case msal.LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case msal.LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const protectedResources = {
    todoListApi: {
        endpoint: "https://agencyhub.unitedwayla.org/hello",
        scopes: ["https://uwlaportals.onmicrosoft.com/tasks-api/tasks.read"],
    },
};
export const loginRequest = {
    scopes: ["openid", "profile", "email"],
};
